import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Roles, RoleService} from "./role.service";
import {Observable} from "rxjs";
import {StringUtils} from "../../../../common/utils";

@Injectable()
export class RolesGuard implements CanActivate, CanActivateChild {

    public static readonly UNAUTHORIZED_PAGE = '/space/unauthorized';

    public static guards = [];

    constructor(private _router: Router, private roleService: RoleService) {
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.checkAccess(state);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.checkAccess(state);
    }

    private checkAccess(state: RouterStateSnapshot): boolean {
        const granted = StringUtils.equalsIgnoreCase(RolesGuard.UNAUTHORIZED_PAGE, state.url)
            || this.roleService.hasAccess(state.url);
        console.log('checkAccess : '+state.url + ": " + granted);
        if (!granted) {
            this._router.navigate([RolesGuard.UNAUTHORIZED_PAGE]);
        }
        return granted;
    }

    static forRoles(roles: string | Roles | Array<string> | Array<Roles>) {

        @Injectable()
        class RolesGuardWithParameters implements CanActivate, CanActivateChild {
            constructor(private _router: Router, private roleService: RoleService) {
            }

            canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
                return this.checkRoles(state);
            }

            canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
                return this.checkRoles(state);
            }

            private checkRoles(state: RouterStateSnapshot): boolean {
                console.log('checkAccess : '+state.url);
                let granted = this.roleService.hasRoles(roles, state.url);
                if (!granted) {
                    this._router.navigate([RolesGuard.UNAUTHORIZED_PAGE]);
                }
                return granted;
            }
        }

        RolesGuard.guards.push(RolesGuardWithParameters);
        return RolesGuardWithParameters;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/roles.guard.ts